export default {
  boxSettings: (state) => state.boxSettings,
  boxSms: (state) => state.boxSms,

  globalLoadingSms: (state) => state.globalLoadingSms,
  i18nDataSms: (state) => state.i18nDataSms,
};
